(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}((function () { 'use strict';

    var FormsCond = {

        init: function init() 
        {
            var formProb = document.getElementById("formProb");
            var formPart = document.getElementById("formPart");
            var imgProb = document.getElementById('prob-img');
            var imgPart = document.getElementById('part-img');
            if (formProb && formPart) {

                document.getElementById('formProb').style.display = "contents";
                imgProb.addEventListener('click', showFormProb);
                imgPart.addEventListener('click', showFormPart);

                function showFormProb() {
                    document.getElementById('formProb').style.display = "contents";
                    document.getElementById('formPart').style.display = "none";
                }
            
                function showFormPart() {
                    document.getElementById('formPart').style.display = "contents";
                    document.getElementById('formProb').style.display = "none";
                }
            }            
        }
    };

    var HelpPage = {
        els: {
            $wrapperNav: null,
            $navbar: null,
            $wrapperSearch: null,
            $searchbar: null,
            $question: null,
            $submenu: null,
        },
        stickyOffsetPosition: null,

        init: function init() {
            if (typeof help_page_options !== 'undefined') {
                this.els.$wrapperNav = document.querySelector('.js-help-page-navbar');
                
                if (this.els.$wrapperNav) {
                    
                    // Navbar
                    this.els.$navbar = document.getElementById("navbar");
                    if(navbar) {
                        this.initNavbar();
                        this.initCollapsible();
                    }
                }

                this.els.$wrapperSearch = document.querySelector('.js-help-page-search');
                
                if (this.els.$wrapperSearch) {   
                    // Navbar
                    this.els.$searchbar = document.getElementById("search");
                    if(this.els.$searchbar) {
                        this.initShearch();
                    }
                }

                this.els.$question = document.querySelectorAll(".sub-arrow");
                if(this.els.$question){
                    this.toggleArrow();
                }

                this.els.$submenu = document.querySelectorAll(".submenu");
                if(this.els.$submenu){
                    this.hideSubsubmenu(this.els.$submenu);
                }
            }

        },

        initShearch: function initShearch() {

            var input, filter, i, txtValue, count, rien, title;
            var buton = document.getElementById("searchSub");
            var all = document.getElementById("all-content");
            var section = all.getElementsByClassName("sectionContent");
            var InstantSearch = {

                "highlight": function (container, highlightText)
                {
                    var internalHighlighter = function (options)
                    {
            
                        var id = {
                            container: "container",
                            tokens: "tokens",
                            all: "all",
                            token: "token",
                            className: "className",
                            sensitiveSearch: "sensitiveSearch"
                        },
                        tokens = options[id.tokens],
                        allClassName = options[id.all][id.className],
                        allSensitiveSearch = options[id.all][id.sensitiveSearch];
            
            
                        function checkAndReplace(node, tokenArr, classNameAll, sensitiveSearchAll)
                        {
                            var nodeVal = node.nodeValue, parentNode = node.parentNode,
                                i, j, curToken, myToken, myClassName, mySensitiveSearch,
                                finalClassName, finalSensitiveSearch,
                                foundIndex, begin, matched, textNode, span, isFirst;
            
                            for (i = 0, j = tokenArr.length; i < j; i++)
                            {
                                curToken = tokenArr[i];
                                myToken = curToken[id.token];
                                myClassName = curToken[id.className];
                                mySensitiveSearch = curToken[id.sensitiveSearch];
            
                                finalClassName = (classNameAll ? myClassName + " " + classNameAll : myClassName);
            
                                finalSensitiveSearch = (typeof sensitiveSearchAll !== "undefined" ? sensitiveSearchAll : mySensitiveSearch);
            
                                isFirst = true;
                                while (true)
                                {
                                    if (finalSensitiveSearch)
                                        { foundIndex = nodeVal.indexOf(myToken); }
                                    else
                                        { foundIndex = nodeVal.toLowerCase().indexOf(myToken.toLowerCase()); }
            
                                    if (foundIndex < 0)
                                    {
                                        if (isFirst)
                                            { break; }
            
                                        if (nodeVal)
                                        {
                                            textNode = document.createTextNode(nodeVal);
                                            parentNode.insertBefore(textNode, node);
                                        } // End if (nodeVal)
            
                                        parentNode.removeChild(node);
                                        break;
                                    } // End if (foundIndex < 0)
            
                                    isFirst = false;
            
            
                                    begin = nodeVal.substring(0, foundIndex);
                                    matched = nodeVal.substr(foundIndex, myToken.length);
            
                                    if (begin)
                                    {
                                        textNode = document.createTextNode(begin);
                                        parentNode.insertBefore(textNode, node);
                                    } // End if (begin)
            
                                    span = document.createElement("span");
                                    span.className += finalClassName;
                                    span.appendChild(document.createTextNode(matched));
                                    parentNode.insertBefore(span, node);
            
                                    nodeVal = nodeVal.substring(foundIndex + myToken.length);
                                } // Whend
            
                            } // Next i 
                        }        
                        function iterator(p)
                        {
                            if (p === null) { return; }
            
                            var children = Array.prototype.slice.call(p.childNodes), i, cur;
            
                            if (children.length)
                            {
                                for (i = 0; i < children.length; i++)
                                {
                                    cur = children[i];
                                    if (cur.nodeType === 3)
                                    {
                                        checkAndReplace(cur, tokens, allClassName, allSensitiveSearch);
                                    }
                                    else if (cur.nodeType === 1)
                                    {
                                        iterator(cur);
                                    }
                                }
                            }
                        }        
                        iterator(options[id.container]);
                    } // End Function highlighter
                    ;
            
            
                    internalHighlighter(
                        {
                            container: container
                            , all:
                                {
                                    className: "highlighter"
                                }
                            , tokens: [
                                {
                                    token: highlightText
                                    , className: "highlight"
                                    , sensitiveSearch: false
                                }
                            ]
                        }
                    ); // End Call internalHighlighter 
            
                } // End Function highlight
            
            };

            function goSearch(){
                rien = document.getElementById("rien");
                input = document.getElementById("search");
                filter = input.value.toUpperCase();            
                title = document.getElementsByClassName("heading-title");
                jQuery(".highlight").removeClass("highlight highlighter");
                
                count = 0;
                if(filter != ""){
                    for (i = 0; i < title.length; i++) {
                        title[i].style.display = "none";
                    }                
                    
                    for (i = 0; i < section.length; i++) {
                        txtValue = section[i].innerText;
                        //search and replace
                        
                        if (txtValue.toUpperCase().indexOf(filter) > -1) {

                            InstantSearch.highlight(section[i], input.value);
                            resultat.style.display = "flex";
                            resultat.innerHTML = "Result for: " + input.value;
                            section[i].style.display = "";
                            count += 1;

                        } else {
                            section[i].style.display = "none";
                        }
                    }

                    if(count == 0)
                    {
                        resultat.style.display = "none";
                        all.style.overflowY = "auto";
                        rien.style.display = "flex";
                        rien.innerHTML = "No result found: " + input.value;
                    }
                    else {
                        all.style.overflowY = "scroll";
                        rien.style.display = "none";
                    }
                }
            }

            jQuery("#search").keyup(function(event) {
                if (event.keyCode === 13) {
                    goSearch();
                }
            });
            buton.addEventListener("click", function() {
                goSearch();
            });
        },
        

        initNavbar: function initNavbar() {

            function getOffset( el ) {
                var _y = 0;
                while( el && !isNaN( el.offsetTop ) ) {
                    _y += el.offsetTop - el.scrollTop;
                    el = el.offsetParent;
                }
                return _y;
            }

            //Y position off the navbar in pixel
            var offset = getOffset(navbar);
            // When the user scrolls the page, execute myFunction
            window.onscroll = function() {
                
                if (window.pageYOffset + 72 >= offset) {
                    // Add the sticky class to the navbar when you reach its scroll position.
                    navbar.classList.add("sticky");
                } else {//Remove "sticky" when you leave the scroll position
                    navbar.classList.remove("sticky");
                }
            };
        },

        initCollapsible: function initCollapsible() {
            var coll = document.getElementsByClassName("collapsible");
            var i;

            for (i = 0; i < coll.length; i++) {
                
                coll[i].addEventListener("click", function() {
                    this.classList.toggle("active");
                    var navcontent = this.nextElementSibling;
                    if (navcontent.style.display === "block") {
                        navcontent.style.display = "none";
                    } else {
                        navcontent.style.display = "block";
                    }
                });
            }
        },
        
        toggleArrow: function toggleArrow(){
            var questions = document.querySelectorAll(".sub-arrow");
            questions.forEach(function (question, i) {
                question.addEventListener('click', function() {
                    var svg = document.querySelectorAll(".q-arrow");
                    if (svg[i].classList.contains('rotate-menu')) {
                        svg[i].classList.remove('rotate-menu');
                        svg[i].classList.add('rotate-menu-back');
                    } else if (svg[i].classList.contains('rotate-menu-back')) {
                        svg[i].classList.remove('rotate-menu-back');
                        svg[i].classList.add('rotate-menu');
                    } else {
                        svg[i].classList.add('rotate-menu');
                    }
                });
            });
        },

        hideSubsubmenu: function hideSubsubmenu(submenu){
            jQuery(submenu).each(function() {
                if (jQuery(this).find("#subsubmenu").children().length == 0){
                    jQuery(this).hide();
                }
            });
        }
    };

    var Apihover = {

        init: function init() 
        {
            var zoneApi = document.querySelectorAll(".api-sec");
            
            if(zoneApi){
                zoneApi.forEach(function (element) {

                    var btnRead = element.querySelector('.elementor-button-link');
                    var imgApi = element.querySelector('img');

                    element.addEventListener("mouseenter", function( event ) {
                        element.classList.add("shadowAPI");
                        imgApi.classList.add("opacityone");
                    });
                    element.addEventListener("mouseleave", function( event ) {
                        imgApi.classList.remove("opacityone");
                        element.classList.remove("shadowAPI");
                    });
                    
                    if(btnRead && btnRead.href){
                        element.addEventListener("click", function( event ) {
                            window.location = btnRead.href;
                        });   
                    }
                });
            }   
        }
    };

    var SolucePage = {

        init: function init() 
        {
            var archSoluce = document.querySelectorAll(".soluarchive");

            if(archSoluce){
                archSoluce.forEach(function (element) {

                    var uniSoluce = element.children[0].querySelectorAll(".solutions");

                    uniSoluce.forEach(function (element) {

                        var btnRead = element.querySelector('.elementor-post__read-more');

                        element.addEventListener("mouseenter", function( event ) {
                            element.classList.add("shadow");
                        });
                        element.addEventListener("mouseleave", function( event ) {
                            element.classList.remove("shadow");
                        });                    
                        element.addEventListener("click", function( event ) {
                            window.location = btnRead.href;
                        });   
                    });
                });
            }        

            if(jQuery('.button-solution').find('a').attr("href") != null){
                jQuery('.button-solution').css("display", "block");
            }

            jQuery('.hide').each(function(){
                jQuery(this).parent().hide();
            });
        }
    };

    var Menu = {
        init: function init() {
            jQuery('.toggleSubMenu').click(function () {
                jQuery('.elementor-menu-toggle').click();
                jQuery(this).find('.sub-menu').toggleClass('open');
            });
        }
    };

    if(window.elementorFrontend !== undefined) {
        window.elementorFrontend.elements.$window.one('elementor/frontend/init', function () {
            // Elementor frontend is loaded
            (function () {
                var Config = theme_config || {};
                FormsCond.init();
                HelpPage.init();
                Apihover.init();
                SolucePage.init();
                Menu.init();
            })();
        });
    }

})));
//# sourceMappingURL=wwl.min.js.map
